import { Box, Card, Text } from '@nimbus-ds/components';
import { useTranslationCatalog } from 'domains/Catalog/hooks';
import { ScopeSelector } from './ScopeSelector';
import { MetaplanFormProps } from '../MetaplanForm';

type ApplyToCardProps = Pick<
  MetaplanFormProps,
  'mode' | 'values' | 'errors' | 'onChangeProducts'
> & {
  excludedProductIds?: string[];
};

export function ApplyToCard({
  mode,
  values,
  errors,
  onChangeProducts,
  excludedProductIds = [],
}: Readonly<ApplyToCardProps>) {
  const t = useTranslationCatalog();

  return (
    <Card>
      <Card.Header title={t('subscriptions.form.products.title')} />
      <Card.Body>
        <Box display="flex" flexDirection="column" gap="3">
          <Text fontSize="base" color="neutral-textLow">
            {t('subscriptions.form.products.subtitle')}
          </Text>
          <ScopeSelector
            disabled={mode === 'edit'}
            values={values}
            errors={errors}
            onChangeProducts={onChangeProducts}
            excludedProductIds={excludedProductIds}
          />
        </Box>
      </Card.Body>
    </Card>
  );
}
